import React from 'react';
import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 0,
  borderRadius: 10,
  overflow: 'hidden',
};

interface ModalMAIQProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  hideDefaultCloseButton?: boolean;
  customStyle?: React.CSSProperties;
}

const ModalMAIQ = ({ 
  open, 
  onClose, 
  children, 
  hideDefaultCloseButton = false,
  customStyle = {}
}: ModalMAIQProps) => {
  return (
    <Modal open={open} onClose={onClose} disablePortal>
      <Box sx={{...modalStyle, ...customStyle}}>
        {!hideDefaultCloseButton && (
          <IconButton 
            onClick={onClose} 
            sx={{ position: 'absolute', right: 8, top: 8, zIndex: 10 }}
          >
            <CloseIcon />
          </IconButton>
        )}
        {children}
      </Box>
    </Modal>
  );
};

export default ModalMAIQ;